import { Component } from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import styled, { createGlobalStyle } from 'styled-components'
import { connect } from 'react-redux'
import classnames from 'classnames'

import ContactPreferencesForm from './PersonalDetail/ContactPreferencesForm'
import { User as UserService, PreferedLanguages as PreferedLanguagesService } from '../../services'
import { hiDPIpx } from '../../utils'
import mq from '../../utils/styled-mq'
import Text from '../Text'
import { setMe, signOut, setUserDataFromAPI as setUserDataFromAPIAction } from '../../stores/user'
import tokens from '@mch-group/design-tokens/build/js/design_tokens-module'
import { Col, Container, Row, Spinner } from '@mch-group/uikit-components'

const mID = 'otm-unsubscribe'

class Unsubscribe extends Component {
  static propTypes = {
    className: PropTypes.string,
    uco_grp1_title: PropTypes.string,
    store: PropTypes.object,
    user: PropTypes.object,
    setMe: PropTypes.func,
    setUserDataFromAPI: PropTypes.func,
    signOut: PropTypes.func,
    isLoggedIn: PropTypes.bool
  }

  state = {
    data: null,
    preferedLanguages: [],
    unsubscribeLoginStatus: false,
    formError: null
  }

  async componentDidMount() {
    //@ts-ignore and check if user is/not logged in
    if (this.props.isLoggedIn) {
      //@ts-ignore
      await this.props.setUserDataFromAPI()
    } else {
      this.handleLoggedOutUserSubscriptions()
    }
  }

  async componentDidUpdate(prevProps) {
    //@ts-ignore
    if (prevProps.user.me !== this.props.user.me) {
      const url = this.handleQueryString()
      //@ts-ignore
      const { me } = this.props.user
      // case 1: nothing in qs
      // case 2: the qs doesnt belong to this logged user
      // case 3: the qs belongs to this logged user
      //@ts-ignore
      if (typeof url.userCrmGuid === 'undefined') {
        this.handleLoggedInUserSubscriptions()
        //@ts-ignore
      } else if (me.crmGuid !== url.userCrmGuid) {
        //@ts-ignore
        await this.props.signOut()
        // force reload and keeps the correct qs (avoids space issue in url parsing from our app/nextjs)
        // bug: "/unsubscribed?guid=xxx" is converted to "/unsubscribed ?guid=xxx" or "/unsubscribed%20?guid=xxx"
        window.location.reload()
      } else {
        this.handleLoggedInUserSubscriptions()
      }
    }
  }

  setFormError = (e) => {
    this.setState({ formError: e })
  }

  handleLoggedInUserSubscriptions = () => {
    PreferedLanguagesService.getPreferedLanguages().then(({ data }) => {
      this.setState({
        //@ts-ignore
        data: this.props.user.me,
        preferedLanguages: data,
        unsubscribeLoginStatus: true
      })
    })
  }

  handleLoggedOutUserSubscriptions = () => {
    const url = this.handleQueryString()
    if (url) {
      const allPromises = [UserService.userSubscriptions(url, true), PreferedLanguagesService.getPreferedLanguages()]
      Promise.all(allPromises).then((response) => {
        this.setState({
          data: response[0].data,
          preferedLanguages: response[1].data,
          unsubscribeLoginStatus: false
        })
      })
    }
  }

  handleQueryString = () =>
    (global.location
      ? qs.parse(global.location.search.replace('token', 'crmToken').replace('guid', 'userCrmGuid'))
      : null)

  render() {
    const { data } = this.state

    if (!data) {
      return (
        <Container className='px-5 px-lg-8 px-md-7 mt-0'>
          <Spinner theme='light' variant='page' />
        </Container>
      )
    //@ts-ignore
    } else if (data.status === 404 || data.status === 400) {
      return (
        <Container className='px-5 px-lg-8 px-md-7 mt-0'>
          {/** @ts-ignore */}
          <Text forwardedAs='p'>{this.props.store.valmsg_user_not_found}</Text>
        </Container>
      )
    }
    return (
      // @ts-ignore
      <Container className={classnames(this.props.className, 'px-5 px-lg-8 px-md-7 mt-0')}>
        <Row className={mID}>
          <Row>
            <Col lg={8}>
              {/** @ts-ignore */}
              <h2>{this.props.uco_grp1_title}</h2>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={12} lg={4}>
              {this.state.formError && (
                <Text isSmall className='form-error-message'>
                  {this.state.formError}
                </Text>
              )}
              <ContactPreferencesForm
                //@ts-ignore
                data={this.props}
                unsubscribeData={this.state.data}
                unsubscribeUrl={this.handleQueryString()}
                unsubscribeLoginStatus={this.state.unsubscribeLoginStatus}
                preferedLanguages={this.state.preferedLanguages}
                //@ts-ignore
                store={this.props.store}
                setFormError={this.setFormError}
                //@ts-ignore
                setMe={this.props.setMe}
              />
            </Col>
          </Row>
        </Row>
        <GlobalStyle />
      </Container>
    )
  }
}

const GlobalStyle = createGlobalStyle`
  body {
    background-color: var(--bs-mch-white);
  }
`

const UnsubscribeConnected = connect(
  ({ shared, user }) => ({
    store: shared.globalModules.validationMessageModule.labels,
    user,
    isLoggedIn: user.loginData && true
  }),
  {
    setMe, signOut, setUserDataFromAPI: setUserDataFromAPIAction
  }
)(Unsubscribe)

const StyledUnsubscribe = styled(UnsubscribeConnected)`
  .${mID} {
    margin-bottom: 105px;
    ${mq.between('tablet', 'largestTablet')`
      margin-bottom: ${hiDPIpx(50)};
    `}
    ${mq.lessThan('largestMobile')`
      margin-bottom: ${MFP.vars['50px']};
    `}

    h4.ui.header {
      margin-bottom: ${MFP.vars['6px']};
      ${mq.between('tablet', 'largestTablet')`margin-bottom: ${MFP.vars['14px']}`};
      ${mq.lessThan('largestMobile')`margin-bottom: ${MFP.vars['9px']}`};
    }

    .row {
      &:first-child {
        padding-top: ${MFP.vars['4px']};
        ${mq.lessThan('largestTablet')`padding-top: 0`};
      }
    }

    .ui.form > .grid > .row {
      &:first-child {
        margin-bottom: -${MFP.vars['11px']};
      }

      &:last-child {
        margin-top: 0;
        ${mq.between('tablet', 'largestTablet')`margin-top: ${MFP.vars['66px']}`};
        ${mq.lessThan('largestMobile')`margin-top: ${MFP.vars['44px']}`};

        .column:first-child {
          ${mq.between('tablet', 'largestTablet')`margin-bottom: ${MFP.vars['20px']}`};
          ${mq.lessThan('largestMobile')`margin-bottom: ${MFP.vars['13px']}`};
        }
      }

      .field > label {
        font-family: ${tokens.fontFamilies.artBaselText.value};
      }
    }

    .ui.checkbox:not(.radio) label {
      font-weight: ${tokens.fontWeights.artBaselHeadline0.value};
      padding-left: ${MFP.vars['40px']};
    }

    .preferences-form {
      &__subscribe.row {
        margin-bottom: 0;
      }

      .flex-row {
        display: flex;
      }

      &__label {
        margin-left: ${MFP.vars['5px']};
        margin-bottom: ${MFP.vars['27px']};
        ${mq.between('tablet', 'largestTablet')`margin-top: ${MFP.vars['8px']}`};
        ${mq.lessThan('largestMobile')`
          margin-top: ${MFP.vars['5px']};
          margin-bottom: ${MFP.vars['17px']}
        `}
      }

      &__language {
        &--item:first-child {
          order: 2;
        }

        &--item:last-child {
          order: 1;
        }
      }
    }
  }
`

export default StyledUnsubscribe
